import Container from "./Container";
import Text from "./Text";
import { Button } from "primereact/button";
import Icon from "./Icon";
import { useTaxImportContext } from "../contexts/TaxImportContext";
import { AnalyticsEvent, Tracker } from "../analytics";

interface IEmptyWalletStateProps {
    onAddAsset: () => void;
}

const EmptyWalletState = ({ onAddAsset }: IEmptyWalletStateProps) => {
    const { openImportTax } = useTaxImportContext();

    return (
        <Container 
            center 
            fullWidth 
            flexColumn 
            className="py-8 px-4"
            gap={4}
            style={{ minHeight: '60vh' }}
        >
            <Container 
                flexColumn 
                center 
                gap={4}
                className="max-w-md"
            >
                <Container flexColumn center gap={2} className="text-center">
                    <div style={{ 
                        marginBottom: '0.5rem',
                        animation: 'fadeInUp 0.6s ease-out 0.2s both'
                    }}>
                        <Text 
                            size="3xl" 
                            color="900" 
                            fontWeight="bold"
                        >
                            Sua carteira está vazia
                        </Text>
                    </div>
                    
                    <div style={{ 
                        lineHeight: '1.6',
                        maxWidth: '400px',
                        animation: 'fadeInUp 0.6s ease-out 0.3s both'
                    }}>
                        <Text 
                            size="lg" 
                            color="600" 
                            fontWeight="normal"
                            className="text-center"
                        >
                            Comece a construir seu patrimônio adicionando seus primeiros investimentos
                        </Text>
                    </div>
                </Container>

                <Container 
                    center 
                    wrap
                    gap={2}
                    className="mt-2"
                    style={{ 
                        animation: 'fadeInUp 0.6s ease-out 0.4s both'
                    }}
                >
                    <Button
                        icon="pi pi-plus-circle"
                        label="Adicionar primeiro ativo"
                        onClick={() => {
                            Tracker.track(AnalyticsEvent.HomeEmptyAddAssetTapped);
                            onAddAsset();
                        }}
                        className="p-button-lg"
                        style={{
                            padding: '0.875rem 1.75rem',
                            fontSize: '1rem',
                            fontWeight: '600',
                            borderRadius: '0.5rem',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                            transition: 'all 0.3s ease'
                        }}
                    />
                    <Button
                        icon="pi pi-file-import"
                        label="Importar declaração (IR)"
                        onClick={openImportTax}
                        className="p-button-lg p-button-outlined"
                        title="Importação DIRPF"
                        style={{
                            padding: '0.875rem 1.75rem',
                            fontSize: '1rem',
                            fontWeight: '600',
                            borderRadius: '0.5rem',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                            transition: 'all 0.3s ease'
                        }}
                    />
                </Container>

                <Container 
                    flexColumn 
                    center 
                    gap={3} 
                    className="mt-6 pt-6"
                    style={{ 
                        borderTop: '1px solid #e5e7eb',
                        width: '100%',
                        animation: 'fadeInUp 0.6s ease-out 0.5s both'
                    }}
                >
                    <Text size="sm" color="500" fontWeight="medium" className="text-center">
                        Dicas para começar:
                    </Text>
                    
                    <Container flexColumn gap={2} className="w-full">
                        <Container gap={2} itemsCenter>
                            <Icon 
                                name="pi-check-circle" 
                                className="text-green-500"
                                size={4}
                            />
                            <Text size="sm" color="600" className="text-left">
                                Adicione seus investimentos em renda fixa e variável
                            </Text>
                        </Container>
                        
                        <Container gap={2} itemsCenter>
                            <Icon 
                                name="pi-check-circle" 
                                className="text-green-500"
                                size={4}
                            />
                            <Text size="sm" color="600" className="text-left">
                                Registre seus imóveis e veículos
                            </Text>
                        </Container>
                        
                        <Container gap={2} itemsCenter>
                            <Icon 
                                name="pi-check-circle" 
                                className="text-green-500"
                                size={4}
                            />
                            <Text size="sm" color="600" className="text-left">
                                Acompanhe a evolução do seu patrimônio em tempo real
                            </Text>
                        </Container>
                    </Container>
                </Container>
            </Container>

            <style>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </Container>
    );
};

export default EmptyWalletState;

